<app-timesheet-view *ngIf="!TimesheetVieworEntry" [ViewInputProperty]="isListorUpdateView"
  (ViewOutputTimesheet)="EmitChildComponent($event)"></app-timesheet-view>
<app-timesheet-entry *ngIf="TimesheetVieworEntry" [EntryInputProperty]="isListorUpdateView"
  (EntryOutputTimesheet)="EmitChildComponent($event)"></app-timesheet-entry>



  
